import { Preferences } from '@capacitor/preferences';
import { SplashScreen } from '@capacitor/splash-screen';
import { SafeArea } from 'capacitor-plugin-safe-area';
import Envir from '../components/Envir';
import { setThemeFromCookie } from '../utils/ThemeUtils.js';
import  { setCssVarValue} from '../utils/CssUtils.js';

export const SECOND = 1000;
export const MINUTE = 60000;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;
export const WEEK = DAY * 7;
export const MONTH = WEEK * 4;
export const YEAR = MONTH * 12;
export const SHARED_POST_SLEEPING_INTERVAL = 50;

let appWasAlreadyInvoked = false;
let isAndroidSaveArea = false;

export function getCurrentTimeInMiliSec() {
  return new Date().getTime();
}

export async function setIOSCookie(key, value, expiration) {
  // if expiration = 0, we need to imitate session cookie, so we put 24 hours
  // expiration (edt) comes from server in seconds, so we need to convert it milliseconds : expiration * SECOND
  let expiryDateMs = (expiration === 0) ? getCurrentTimeInMiliSec() + 24 * HOUR : expiration * SECOND;
  let valueObj = {
    value: encodeURIComponent(value),
    expiration: expiryDateMs
  };
  let val = JSON.stringify(valueObj);
 
  await Preferences.set({ key: key, value: val });
}

export async function getIOSCookie(key) {
  let cookieValue;
  let valueObj;
  let value = "";

  cookieValue = await Preferences.get({ key: key })
  if (cookieValue.value !== null) {
    valueObj = JSON.parse(cookieValue.value);
    if (getCurrentTimeInMiliSec() < valueObj.expiration) {
      value = valueObj.value;
    } 
    else {
      await deleteIOSCookie(key);
    }
  }
  return value;
}

export async function deleteIOSCookie(key) {
  await Preferences.remove({ key: key });
};

export function iOSstatusBarPadding() {
  if (Envir.iOS_APP || (Envir.ANDROID_APP && isAndroidSaveArea) ) {
    return (
      <div className="iphoneIpadInset">
      </div>
    )
  }
  else {
    return <div></div>;
  }
}

export async function hideSplashScreen() {
  try {
    await SplashScreen.hide();
  }
  catch (error) {
    console.log(error);
  }
}

export async function hideSplashScreenForApp() {
  await hideSplashScreen();
}

export async function setThemeFromCookieSync() {
  (async () => await setThemeFromCookie())(); // call async function from sync
}

export function setAppWasAlreadyInvoked(option) {
  appWasAlreadyInvoked = option;
}

export function getAppWasAlreadyInvoked() {
  // deactivate this featue because the issie is gone: App.js is not invoked twice with deep link
  // below statement will ALWAYS return false and it apices compiler
  let retCond = appWasAlreadyInvoked ? false : appWasAlreadyInvoked;
  
  return retCond; // deactivate this featue because the issie is gone (appWasAlreadyInvoked);
}

export function setSaveAreaForAndroidIOSApp1() {
  let adjustAndroidGoTopForAnd17Value = '55px';
  let adjustSearchArrowHeightForAnd17Value = '45px';
  let searchEraserXPositionForAnd17Value =  "fixed";
  let searchEraserXTopForAnd17Value = "calc(var(--safe-area-top) + 25px)";
 
  setCssVarValue('--safe-area-top', 'env(safe-area-inset-top, 0px)'); // used in iphoneIpadInset
  if (Envir.ANDROID_APP) {
    setCssVarValue('--safe-area-bottom', 'env(safe-area-inset-bottom, 0px)');
    checkAndroidSafeArea().then((safeAreaIsPresent) => {
      if (safeAreaIsPresent) {
        setCssVarValue('--adjustAndroidGoTopForAnd17', adjustAndroidGoTopForAnd17Value);
        setCssVarValue('--adjustSearchArrowHeightForAnd17', adjustSearchArrowHeightForAnd17Value);
        setCssVarValue('--searchEraserXPositionForAnd17', searchEraserXPositionForAnd17Value );
        setCssVarValue('--searchEraserXTopForAnd17', searchEraserXTopForAnd17Value );
        document.documentElement.setAttribute('data-android-ios-app', "true");
      }
    });
  } 
}

export async function checkAndroidSafeArea() {
  if (!isAndroidSaveArea) {
    try {
      const { insets } = await SafeArea.getSafeAreaInsets();
      console.log(`Native insets - top: ${insets.top}px, Present: ${insets.top > 0}`);
      isAndroidSaveArea = (insets.top > 0);
      return isAndroidSaveArea;
    } catch (e) {
      console.warn('SafeArea plugin failed', e);
      return false;
    }
  }
}

export async function setSaveAreaForAndroidIOSApp() {
  let adjustAndroidGoTopForAnd17Value = '55px';
  let adjustSearchArrowHeightForAnd17Value = '45px';
  let searchEraserXPositionForAnd17Value =  "fixed";
  let searchEraserXTopForAnd17Value = 25;
  let safeAreaData = await getAndroidIOSSafeArea();
  const { insets } = safeAreaData;

  if (insets.top > 0) {
    document.documentElement.setAttribute('data-android-ios-app', "true");
    if (Envir.ANDROID_APP) {
      document.documentElement.setAttribute('data-android-app', "true");
    }
    isAndroidSaveArea = true;
    //
    setCssVarValue('--safe-area-top', `${insets.top}px`);
    setCssVarValue('--safe-area-bottom', `${insets.bottom}px`);
    setCssVarValue('--safe-area-left', `${insets.left}px`);
    //      
    setCssVarValue('--adjustAndroidGoTopForAnd17', adjustAndroidGoTopForAnd17Value);
    setCssVarValue('--adjustSearchArrowHeightForAnd17', adjustSearchArrowHeightForAnd17Value);
    setCssVarValue('--searchEraserXPositionForAnd17', searchEraserXPositionForAnd17Value);
    //
    searchEraserXTopForAnd17Value += insets.top;
    setCssVarValue('--searchEraserXTopForAnd17', `${searchEraserXTopForAnd17Value}px` );
  } 
}

export async function getAndroidIOSSafeArea() {
  let safeAreaData = { insets: { top: 0, bottom: 0, left: 0, right: 0 } };

  try {
    safeAreaData = await SafeArea.getSafeAreaInsets();
    console.log(`Native insets - top: ${safeAreaData.insets.top}px, bottom: ${safeAreaData.insets.bottom}px`);
  } catch (e) {
    console.warn('SafeArea plugin failed', e);
  }
  return safeAreaData;
}